goog.provide('el8.appservice.highlighter');


el8.appservice.highlighter = (function() {

    var _SearchTerms = null;
    var _SearchTermsArray = null

    return {
        highlightText: function(text) {
            if (_SearchTerms && text.indexOf("<span") == -1) {
                var result = text.replace(_SearchTerms, '<span class="searchHighlighted">$1</span>'); // XSS OK -KF
                return result;
            } else {
                return text;
            }
        },
        setSearchTerms: function(termsList) {
            if (termsList) {
                var wildcardTerms = [];
                var wholeTerms = [];
                for (var i=0; i<termsList.length; i++) {
                    var term = termsList[i];
                    if (term.length > 2) {
                        wildcardTerms[wildcardTerms.length] = RegExp.escape(term); // Escape special characters so we get a literal match.
                    }
                    else {
                        // Don't wildcard for short terms (kind of a hack until we get better stemming functionality here)
                        wholeTerms[wholeTerms.length] = RegExp.escape(term);
                    }
                }
                _SearchTermsArray = wildcardTerms.concat(wholeTerms)

                if (wildcardTerms.length && wholeTerms.length) {
                    var pipedWild = wildcardTerms.join('|');
                    var pipedWhole = wholeTerms.join('|');
                    _SearchTerms = RegExp("\\b((" + pipedWild + ")\\S*|(" + pipedWhole + ")\\b)", "gi");

                } else if (wildcardTerms.length) {
                    var piped = wildcardTerms.join('|');
                    _SearchTerms = RegExp("\\b((" + piped + ")\\S*)", "gi");

                } else if (wholeTerms.length) {
                    var piped = wholeTerms.join('|');
                    _SearchTerms = RegExp("\\b((" + piped + ")\\b)", "gi");
                }
            } else {
                _SearchTerms = null;
                _SearchTermsArray = null;
            }
        },
        getSearchTerms: function() { return _SearchTerms; },

        getSearchTermsArray: function() { return _SearchTermsArray; }
    };

})();
